module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "page-bar hide"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/workspace/"
    }
  }, [_vm._v("Workspace")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "page-toolbar hide"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right module-zone",
    attrs: {
      "role": "menu"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsStash,
      "type": 'widgetsStash',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1)])])]), _vm._v(" "), _c('breadcrumb-bar', {
    attrs: {
      "crumbs": ['Organization Forms']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "first-column"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsFirst,
      "type": 'widgetsFirst',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 db-column",
    attrs: {
      "id": "second-column"
    }
  }, [_c('widget', {
    attrs: {
      "name": _vm.widgets.widgetsSecond,
      "type": 'widgetsSecond',
      "draggable": ".portlet"
    },
    on: {
      "passWidgets": _vm.widgetsData
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', [_vm._v("Organization Forms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-fit-height grey-salt dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-delay": "1000",
      "data-close-others": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Widgets\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b71c000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Workspace.vue
// module id = 1636
// module chunks = 1